import apiWorker from '../apiWorker'

const api_keys = {
    find      : ()      =>  apiWorker('get',    '/api/v1/core/api_keys'),
    create    : (data)  =>  apiWorker('post',   `/api/v1/core/api_keys`, data),
    delete    : (_id)   =>  apiWorker('delete', `/api/v1/core/api_keys/${_id}`),
}

export default api_keys;